import { render } from "./PayFileListShell.vue?vue&type=template&id=4db62be4&scoped=true"
import script from "./PayFileListShell.vue?vue&type=script&lang=js"
export * from "./PayFileListShell.vue?vue&type=script&lang=js"

import "./PayFileListShell.vue?vue&type=style&index=0&id=4db62be4&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db62be4"]])

export default __exports__